import SelectFilter from '../templates/SelectFilter';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { getInstitutions } from '@vindr/services/apis/institution.api';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Institution extends Omit<SelectFilter, 'title' | 'placeholder' | 'options' | 'onChange'> {
  keyValue?: string;
  title?: SelectFilter['title'];
  placeholder?: SelectFilter['placeholder'];
  options?: SelectFilter['options'];
  params?: Parameters<typeof getInstitutions>[0];
  multiple?: boolean;
  onChange?: (
    value: any,
    optionList: ReturnType<typeof useGetInstitutions>['data']['data']
  ) => void;
}

const Institution = ({
  title,
  placeholder,
  value,
  onChange,
  width = 200,
  keyValue = 'id',
  params,
  wrapperClassName,
  multiple = true,
  ...props
}: Institution) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { t } = useTranslation('Vindoc');
  title = ['boolean', 'string'].includes(typeof title) ? title : t('Institution');
  placeholder = placeholder || t('Select Institution');

  const { data, isInitialLoading } = useGetInstitutions({
    offset: 0,
    limit: 100,
    ...params,
    name: searchTerm,
  });
  const institutions = data?.data;

  const options = useMemo(
    () =>
      institutions?.map((item) => ({
        value: item[keyValue],
        label: `${item.name ? item.name : ''}`,
      })),
    [institutions, keyValue]
  );

  return (
    <SelectFilter
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading}
      onSearch={handleSearch}
      onChange={(val) => {
        return onChange(val, institutions);
      }}
      {...{ width, options, placeholder, title, value, wrapperClassName }}
      searchVietnamese
      {...props}
    />
  );
};

export default memo(Institution);
